import { addDays, format, startOfWeek } from "date-fns";

export const ymd = (d: Date) => format(d, "yyyy-MM-dd");

export function weekDays(anchor: Date, weekStart: 0 | 1 = 1): Date[] {
  const start = startOfWeek(anchor, { weekStartsOn: weekStart });
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}

// 4-week grid anchored on Saturday, matching the user's operational Excel
// view. `anchor` is any day; the grid begins on the Saturday of (or just
// before) that day.
export function fourWeekDays(anchor: Date): Date[] {
  const start = startOfWeek(anchor, { weekStartsOn: 6 }); // 6 = Saturday
  return Array.from({ length: 28 }, (_, i) => addDays(start, i));
}

export function isSameYmd(a: Date, b: Date) {
  return ymd(a) === ymd(b);
}
